module.exports = __webpack_public_path__ + "img/17.ed2757bb.jpg";